var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuDash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.16,
    height: 17.111,
    viewBox: "0 0 16.16 17.111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-dashboard-1535343",
    transform: "translate(-163.332 -69.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11915",
    "data-name": "Path 11915",
    d: "M165.233,69.98a1.918,1.918,0,0,0-1.9,1.9v6.654a1.918,1.918,0,0,0,1.9,1.9h3.8a1.918,1.918,0,0,0,1.9-1.9V71.881a1.918,1.918,0,0,0-1.9-1.9Zm0,1.9h3.8v6.654h-3.8Z",
    fill: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11916",
    "data-name": "Path 11916",
    d: "M165.233,349.98a1.918,1.918,0,0,0-1.9,1.9v1.9a1.918,1.918,0,0,0,1.9,1.9h3.8a1.918,1.918,0,0,0,1.9-1.9v-1.9a1.918,1.918,0,0,0-1.9-1.9Zm0,1.9h3.8v1.9h-3.8Z",
    transform: "translate(0 -268.593)",
    fill: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11917",
    "data-name": "Path 11917",
    d: "M375.233,233.31a1.918,1.918,0,0,0-1.9,1.9v6.654a1.918,1.918,0,0,0,1.9,1.9h3.8a1.918,1.918,0,0,0,1.9-1.9v-6.654a1.918,1.918,0,0,0-1.9-1.9Zm0,1.9h3.8v6.654h-3.8Z",
    transform: "translate(-201.445 -156.676)",
    fill: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11918",
    "data-name": "Path 11918",
    d: "M375.233,69.98a1.918,1.918,0,0,0-1.9,1.9v1.9a1.918,1.918,0,0,0,1.9,1.9h3.8a1.918,1.918,0,0,0,1.9-1.9v-1.9a1.918,1.918,0,0,0-1.9-1.9Zm0,1.9h3.8v1.9h-3.8Z",
    transform: "translate(-201.445 0)",
    fill: "#ee3d4a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDash);
export default __webpack_public_path__ + "static/media/menu_dash.1d45557303cf6a0e6a13ce5d5af40930.svg";
export { ForwardRef as ReactComponent };